export default __webpack_public_path__ + "static/media/benefit_16@3x.43126020.png";